export default __webpack_public_path__ + "static/media/mapFrameMedium.30c10ff0.png";